import { ToastContainer } from 'react-toastify';
import styles from './ToastViewport.module.css';

export function ToastViewport() {
  return <ToastContainer position="bottom-center" toastClassName={styles.toast} hideProgressBar stacked />;
}
